/**
 * Build POST /credit-report/import/start payload with explicit provider credential fields.
 * Never sends FundElite app auth credentials — only credit-monitoring portal credentials.
 * Providers that do not require Last 4 SSN / security answers omit those keys entirely.
 */

import { normalizeCapabilityProviderId, providerRequiresVerificationField } from '../config/providerCapabilities';

export function buildProviderImportStartPayload({
  provider,
  useSavedCredentials = false,
  saveCredentials = false,
  oneTimeCredentials = false,
  providerUsername,
  providerPassword,
  providerSecurityAnswer,
  providerUsernameOverride,
  providerPasswordOverride,
  providerSecurityAnswerOverride,
  mockMode = false,
}) {
  const canonicalProvider = normalizeCapabilityProviderId(provider) || provider;
  const requiresVerification = providerRequiresVerificationField(canonicalProvider);
  const base = {
    provider: canonicalProvider,
    use_saved_credentials: Boolean(useSavedCredentials),
    save_credentials: Boolean(saveSavedCredentials(saveCredentials, useSavedCredentials, oneTimeCredentials)),
    one_time_credentials: Boolean(oneTimeCredentials),
  };

  if (mockMode) {
    base.mock_mode = true;
  }

  if (useSavedCredentials) {
    if (requiresVerification) {
      const securityOverride = (providerSecurityAnswerOverride || providerSecurityAnswer || '').trim();
      if (securityOverride) {
        base.provider_security_answer_override = securityOverride;
        base.provider_security_answer = securityOverride;
        base.ssn_last4 = securityOverride;
      }
    }
    const usernameOverride = (providerUsernameOverride || '').trim();
    const passwordOverride = providerPasswordOverride;
    if (usernameOverride && !usernameOverride.includes('*')) {
      base.provider_username_override = usernameOverride;
    }
    if (passwordOverride) {
      base.provider_password_override = passwordOverride;
    }
    return base;
  }

  const username = (providerUsername || '').trim();
  const payload = {
    ...base,
    provider_username: username,
    provider_password: providerPassword,
    username,
    password: providerPassword,
  };

  if (requiresVerification) {
    const security = (providerSecurityAnswer || '').trim();
    payload.provider_security_answer = security;
    payload.ssn_last4 = security;
  }

  return payload;
}

function saveSavedCredentials(saveCredentials, useSavedCredentials, oneTimeCredentials) {
  if (oneTimeCredentials) return false;
  if (useSavedCredentials) return Boolean(saveCredentials);
  return Boolean(saveCredentials);
}
